import type { FC } from "react";
import { IoIosClose } from "react-icons/io";
import { useFotoDeTiendaModal } from "./fotoDeTiendaModalHooks";
import type { FotoDeTiendaModalProps } from "./types";

export const FotoDeTiendaModal: FC<FotoDeTiendaModalProps> = (props) => {
  const { handleClose } = useFotoDeTiendaModal(props);

  return (
    <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-90 p-2 md:p-6">
      <div className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-md">
        <div className="fixed right-3 top-3 z-30 cursor-pointer rounded-full bg-white p-[1px] shadow-sm md:right-6 md:top-6">
          <IoIosClose size={40} onClick={handleClose} />
        </div>
        <img
          src={props.imagen ?? ""}
          alt="imagen de tienda"
          className="max-h-full max-w-full object-contain"
        />
      </div>
    </div>
  );
};
